import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import css from './form-notice.css';

const FormNotice = ({ inverse, text }) => (
  <span
    className={classnames(css['ds-form-notice'], {
      [css['ds-form-notice--inverse']]: inverse,
    })}
  >
    {text}
  </span>
);

FormNotice.defaultProps = {
  inverse: false,
};

FormNotice.propTypes = {
  inverse: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

export default FormNotice;
